export const actualURL = 'https://decision-tree.onrender.com'
// export const actualURL = 'http://localhost:3001' //server is on 3001